<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>评价系统->{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="一级目录设置" name="first">
                <child1></child1>
            </el-tab-pane>
    
            <el-tab-pane label="一二级目录关联" name="second">
                <child2></child2>    
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import ClassEvaluateType from './ClassEvaluateType.vue'
    import ClassEvaluateIndicatorsSet from './ClassEvaluateIndicatorsSet.vue'
    // import ClassEvaluateIndicatorsSet from './ClassEvaluateIndicatorsSet.vue'

    export default {
        name:"ClassEvaluateMain",
        components:{
            child1:ClassEvaluateType,
            child2:ClassEvaluateIndicatorsSet
        },
        data() {
            return {
                //默认第一个选项卡
                activeName: "first",
                title:"一级目录设置"
            }
        },
        methods:{
            handleClick(tab) {
                if(tab.name == "first") {
                    this.title="一级目录设置";
                } else if(tab.name == "second") {
                    this.title="一二级目录关联";
                }
            }
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/classset/ClassEvaluateMain.vue